import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export enum RecipientPermission {
  VIEW_ONLY = 'VIEW_ONLY',
  VIEW_AND_DOWNLOAD = 'VIEW_AND_DOWNLOAD',
}

interface SharedLinkNotificationFile {
  file_id: number;
}

interface SharedLinkNotification {
  id: number;
  files: SharedLinkNotificationFile[];
  recipient_permission: RecipientPermission;
}

interface SharedLinkNotificationResponse {
  vw_dms_shared_link_notification: SharedLinkNotification[];
}

interface SharedLinkNotificationFileResponse {
  fileIds: number[];
  recipientPermission: RecipientPermission;
}

@Injectable({
  providedIn: 'root',
})
export class SharedLinkNotificationApiService {
  constructor(private readonly apollo: Apollo) {}

  getFileIdsByNotificationIds(notificationIds: number[]): Observable<SharedLinkNotificationFileResponse[]> {
    return this.apollo
      .query<SharedLinkNotificationResponse>({
        query: gql`
          query GetSharedLinkNotificationFiles($notificationIds: [Int!]!) {
            vw_dms_shared_link_notification(where: { id: { _in: $notificationIds } }) {
              id
              recipient_permission,
              files(where: {active: {_eq: true}}) {
                file_id
              }
            }
          }
        `,
        variables: { notificationIds },
      })
      .pipe(
        map(({ data }) => data.vw_dms_shared_link_notification.map((notification) => ({
          fileIds: notification.files.map((file) => file.file_id),
          recipientPermission: notification.recipient_permission,
        }))),
      );
  }
}

